import * as React from "react";
import { PrimaryButton, Color, IconName, Text, Size } from "@root/shared";
import { LoginUrlHelper, ReturnUrls } from "../utils/login-url-helper";
import { telemetry } from "@root/test/utils/telemetry";

const styles = require("./login-buttons.scss");
const classNames = require("classnames");

export interface LoginButtonsProps {
  // Nothing to add here yet.
}

export class LoginButtons extends React.Component<LoginButtonsProps, {}> {
  public render() {
    const myWindow = window as any;
    const { initProps = {} } = myWindow;
    const currLocation = myWindow.location || {};
    const returnUrls: ReturnUrls = LoginUrlHelper.buildReturnUrls(currLocation.search, initProps);

    return (
      <div className={styles["external-logins"]}>
        {this.githubButton(returnUrls.github)}
        {this.personalButton(returnUrls.aad)}
        {this.companyButton(returnUrls.aad)}
        <div>
          {this.facebookButton(returnUrls.facebook)}
          {this.googleButton(returnUrls.google)}
        </div>
      </div>
    );
  }

  private facebookButton(returnUrl: string): JSX.Element {
    const buttonClassName = classNames(styles.field, styles["padding-left-m"]);
    return (
      <PrimaryButton
        alignLeft
        className={buttonClassName}
        color={Color.LightGray}
        href={returnUrl}
        icon={IconName.Facebook}
        onClick={() => this.onClick("Facebook")}
      >
        <Text size={Size.Medium}>Facebook</Text>
      </PrimaryButton>
    );
  }

  private googleButton(returnUrl: string): JSX.Element {
    const buttonClassName = classNames(styles.field, styles["padding-left-m"]);
    return (
      <PrimaryButton
        alignLeft
        className={buttonClassName}
        color={Color.LightGray}
        href={returnUrl}
        icon={IconName.Google}
        onClick={() => this.onClick("Google")}
      >
        <Text size={Size.Medium}>Google</Text>
      </PrimaryButton>
    );
  }

  private githubButton(returnUrl: string): JSX.Element {
    const githubButtonClassName = classNames(styles.field, styles["padding-left-m"]);
    return (
      <PrimaryButton
        alignLeft
        className={githubButtonClassName}
        href={returnUrl}
        color={Color.Black}
        icon={IconName.GitHub}
        onClick={() => this.onClick("GitHub")}
      >
        <Text size={Size.Medium} invert>
          GitHub
        </Text>
      </PrimaryButton>
    );
  }

  private personalButton(returnUrl: string): JSX.Element {
    const personalButtonClassName = classNames(styles.field, styles["padding-left-m"]);
    return (
      <PrimaryButton
        alignLeft
        className={personalButtonClassName}
        color={Color.LightGray}
        href={returnUrl}
        icon={IconName.Microsoft}
        onClick={() => this.onClick("Microsoft")}
      >
        <Text size={Size.Medium}>Personal</Text>
      </PrimaryButton>
    );
  }

  private companyButton(returnUrl: string): JSX.Element {
    const companyButtonClassName = classNames(styles.field, styles["padding-left-m"]);
    return (
      <PrimaryButton
        alignLeft
        className={companyButtonClassName}
        color={Color.LightGray}
        href={returnUrl}
        icon={IconName.Microsoft}
        onClick={() => this.onClick("Microsoft")}
      >
        <Text size={Size.Medium}>Company or school</Text>
      </PrimaryButton>
    );
  }

  private onClick(name) {
    const myWindow = window as any;
    const { initProps = {} } = myWindow;
    const fromHockeyApp = initProps.fromHockeyApp;
    if (fromHockeyApp) {
      telemetry.trackEvent(`HockeyApp authentication redirect engage`, { buttonName: name, url: window.location.pathname });
    }
  }
}
